<template>
    <print-layout>
        <div class="print-container">
            <div v-for="(order, index) in orders" :key="index">
                <heading-info
                    :order="order"
                    :type="'outlet_order'"
                />

                <order-list 
                    :order="order"
                    :type="'outlet_order'"
                />

                <div v-if="order.fundraising_code_id" class="text-sm mt-6">
                    Thank you for supporting your school! Produce Express has donated ${{ order.fundraising_amount }}
                    towards {{ order.fundraising_school }} OSNP program! Providing healthy snacks for students!
                </div>

                <div class="text-sm mt-6">
                    Thank you for your order!
                    Please note any concerns with your order must be reported to sales@fresherproduce.ca within <b>the same day</b> of receiving your order.
                </div>

                <div v-if="isAdmin && order.status == -1">
                    <div class="h5 text-muted text-center py-3">
                        - Order Cancelled -
                    </div>
                </div>

                <div class="page-break"></div>

                <!-- Seperate Pages For Subitems -->

                <sub-items
                    :order="order"
                />
            </div>
        </div>
    </print-layout>
</template>

<script>
import UseUserAuth from '@/Composables/UseUserAuth';
import PrintLayout from '@/Layouts/PrintLayout.vue';
import HeadingInfo from '@/Pages/Orders/Prints/Partials/HeadingInfo.vue';
import OrderList from '@/Pages/Orders/Prints/Partials/OrderList.vue';
import SubItems from '@/Pages/Orders/Prints/Partials/SubItems.vue';
import { usePage } from '@inertiajs/inertia-vue3';

export default {
    components: {
        PrintLayout,
        HeadingInfo,
        OrderList,
        SubItems,
    },

    setup () {
        const { isAdmin } = UseUserAuth(usePage().props.value.user);

        return { isAdmin }
    },

    props: ['orders'],

    methods: {
    },

    mounted () {
        window.print();

        window.onafterprint = function() {
            window.close();
        };
        window.onfocus = function() {
            window.close();
        };
    }
}

</script>

<style>
    body {
        font-size: 90%;
        height: 100%;
    }

    table {
        width: 100%;
    }

    table td {
        -webkit-print-color-adjust: exact;
    }

    .combo_with_integrated_subitems {
        background-color: #EEEEEE;
        color: #515558!important;
    }

    .page-break {
        page-break-after: always;
    }

    .subheader th {
        background: #cbcbcb;
        -webkit-print-color-adjust: exact;
    }

    .signature {
        @apply border-r-0 border-l-0 border-t-0 border-b border-gray-dark !important;
    }

    .footer {
        position: fixed;
        bottom: 0px;
        left: 0px;
        width: 100%;
    }

    @media screen {
        .print-container {
            display: none;
        }
    }

    .striped tr:nth-child(even):not(.not_striped) {
        background-color: #f2f2f2;
    }
</style>
